import React, { useState } from "react";
import "./JibuPricing.css";
import SubscribeModal from "./SubscribeModal"; // import the modal
const monthlyPlans = [
  {
    name: "Starter Bot",
    monthlyPrice: "Ksh 1,500/mo",
    annualPrice: "Ksh 15,000/yr",
    setupFee: "Ksh 3,000 one-time",
    features: [
      "Up to 500 chats/month",
      "Web chatbot only",
      "1 language",
      "Basic FAQ training",
      "Email support",
    ],
    highlight: false,
  },
  {
    name: "Growth Bot",
    monthlyPrice: "Ksh 3,500/mo",
    annualPrice: "Ksh 35,000/yr",
    setupFee: "Ksh 5,000 one-time",
    features: [
      "Up to 2,000 chats/month",
      "Web + WhatsApp integration",
      "Up to 2 languages",
      "Custom bot training",
      "WhatsApp API support",
      "WhatsApp & Email support",
    ],
    highlight: true,
  },
  {
    name: "Business Bot",
    monthlyPrice: "Ksh 7,000/mo",
    annualPrice: "Ksh 70,000/yr",
    setupFee: "Ksh 8,000 one-time",
    features: [
      "Unlimited chats",
      "Web, WhatsApp, Facebook, Instagram",
      "Multilingual support (3+ languages)",
      "Advanced bot logic & flows",
      "CRM & email integration",
      "Priority support (Phone, WhatsApp)",
    ],
    highlight: false,
  },
];

const JibuPricing = ({ isDarkMode }) => {
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("");

  const handleSubscribe = (planName) => {
    setSelectedPlan(planName);
    setModalOpen(true);
  };
  return (
    <section className={`jibu-pricing ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <h2>Simple, Transparent Pricing</h2>
      <p className="subtext">Choose a chatbot plan that fits your business.</p>

      {/* Toggle Switch */}
      <div className="billing-toggle">
        <span
          className={billingCycle === "monthly" ? "active" : ""}
          onClick={() => setBillingCycle("monthly")}
        >
          Monthly
        </span>
        <span
          className={billingCycle === "annual" ? "active" : ""}
          onClick={() => setBillingCycle("annual")}
        >
          Annually <small>(Save 2 months)</small>
        </span>
      </div>

      <div className="pricing-grid">
        {monthlyPlans.map((plan, index) => (
          <div
            className={`pricing-card ${plan.highlight ? "highlight" : ""}`}
            key={index}
          >
            <h3>{plan.name}</h3>
            <p className="price">
              {billingCycle === "monthly" ? plan.monthlyPrice : plan.annualPrice}
            </p>
            <p className="setup-fee">{plan.setupFee}</p>
            <ul>
              {plan.features.map((feature, i) => (
                <li key={i}>✔ {feature}</li>
              ))}
            </ul>
            <button className="btn" onClick={() => handleSubscribe(plan.name)}>
              Subscribe
            </button>
          </div>
        ))}
      </div>

      <SubscribeModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        selectedPlan={selectedPlan}
      />
    </section>
  );
};

export default JibuPricing;
